import { render } from "./hotelFliters.vue?vue&type=template&id=aada0018&scoped=true"
import script from "./hotelFliters.vue?vue&type=script&lang=js"
export * from "./hotelFliters.vue?vue&type=script&lang=js"

import "./hotelFliters.vue?vue&type=style&index=0&id=aada0018&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aada0018"]])

export default __exports__